
///<reference path="../control/IController.ts"/>

namespace khi.bk117.model
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Sprite = com.enirva.display.Sprite;
	import Tween = com.enirva.tween.Tween;
	import Debugger = com.enirva.debug.Debugger;
	
	import IController = khi.bk117.control.IController;

	/*
	 * フッタバナーのカルーセル処理
	 */
	class _AppState extends EventDispatcher
	{
		public stageWidth:number;

		public stageHeight:number;

		public scrollPosition:number;

		public maxScrollPosition:number;
		
		public readonly PAGE_ID_HEAD = "Page_";

		private enterFrameFuncs:Function[];

		private enterFrameScopes:any[];

		private onResizeFuncs:Function[];

		private onResizeScopes:any[];

		public isSp:boolean;

		public isTop:boolean;

		public controller:IController;

		/*
		 * ベースURL(config.jsonの定義と同じ)
		 */
		public readonly BASE_URL:string = "/special/techcareer/";

		/*
		 * contentsContainerクラス文字列
		 */
		public readonly FADE_CONTAINER:string = ".globalBodyContainer";

		/*
		 * contentsContainerクラス文字列
		 */
		public readonly CONTAINER:string = ".pjaxContentsContainer";
		
		/*
		 * pageContainerクラス文字列
		 */
		public readonly PAGE_CON:string = ".pjaxPageContainer";

		public readonly FADE_COVER:string = ".pjaxFadeCover";


		public scrollLock:boolean;
		

		public initialLoadTime:number;


		constructor()
		{
			super();

			this.enterFrameFuncs = [];
			this.enterFrameScopes = [];
			this.onResizeFuncs = [];
			this.onResizeScopes = [];

			this.initialLoadTime = (new Date()).getTime();
			
			this.scrollLock = false;
		
			var movefun = function( event )
			{
				if (this.scrollLock)
				{
					event.preventDefault();
				}
			}
			
			// スクロール停止の処理
			window.addEventListener( 'touchmove' , movefun , { passive: false } );
			window.addEventListener( 'scroll' , movefun , { passive: false } );
		}


		/*
		 * bodyタグに付与されている
		 * ページ識別子から、現在ページのIDを取得する
		 */
		public getPageId():string
		{
			var result:string = "";
			var bodyClasses:string[] = $(document.body).attr("class").split(" ");

			for (var i:number = 0, ln = bodyClasses.length; i < ln; i++)
			{
				if (bodyClasses[i].indexOf(this.PAGE_ID_HEAD) >= 0)
				{
					result = bodyClasses[i].replace(this.PAGE_ID_HEAD, "");
					break;
				}
			}

			return result;
		}


		public Initialize():void
		{
			//共通用 EnterFrame処理
			this.onEnterFrame = ():void=>
			{
				this.maxScrollPosition = $("body").height() - $(window).innerHeight();
				
				this.scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

				//console.log(this.enterFrameFuncs.length);

				for (var i:number = 0, ln:number = this.enterFrameFuncs.length; i < ln; i++)
				{
					this.enterFrameFuncs[i].apply(this.enterFrameScopes[i]);
				}
			};

			//共通用　リサイズ処理

			$(window).on("resize", (e:JQueryEventObject):void=>
			{
				this.onResize();
			});

			this.onResize();
		}


		public addEnterFrameFunc(func:Function, scope:any):void
		{
			this.enterFrameFuncs.push(func);
			this.enterFrameScopes.push(scope);
		}


		public removeEnterFrameFunc(func:Function):void
		{
			let resultFuncs:Function[] = [];
			let resultScopes:any[] = [];

			for (var i:number = 0, ln:number = this.enterFrameFuncs.length; i < ln; i++)
			{
				if (this.enterFrameFuncs[i] != func)
				{
					resultFuncs.push(this.enterFrameFuncs[i]);
					resultScopes.push(this.enterFrameScopes[i]);
				}
			}

			this.enterFrameFuncs = resultFuncs;
			this.enterFrameScopes = resultScopes;
		}


		public addResizeFunc(func:Function, scope:any):void
		{
			this.onResizeFuncs.push(func);
			this.onResizeScopes.push(scope);
		}


		public removeResizeFunc(func:Function):void
		{
			let resultFuncs:Function[] = [];
			let resultScopes:any[] = [];

			for (var i:number = 0, ln:number = this.onResizeFuncs.length; i < ln; i++)
			{
				if (this.onResizeFuncs[i] != func)
				{
					resultFuncs.push(this.onResizeFuncs[i]);
					resultScopes.push(this.onResizeScopes[i]);
				}
			}

			this.onResizeFuncs = resultFuncs;
			this.onResizeScopes = resultScopes;
		}


		public setLinkEvent(target:JQuery):void
		{
			const link:string = "#" + target.attr("href").split("#")[1];
			
			//target.attr("href", "javascript:void(0)");
			target.on("click", ()=>
			{
				if ($(link).length > 0)
				{
					$("html,body").animate({scrollTop:$(link).offset().top}, 600, "swing");
					return false;
				}
				else
				{
					//
				}
			});
		}


		public getMousePosition(e:any):{x:number, y:number}
		{
			let result:{x:number, y:number} = {
				x : 0, y : 0
			};

			if (e.touches)
			{
				result.x = e.touches[0].pageX;
				result.y = e.touches[0].pageY;
			}
			else
			{
				result.x = e.pageX;
				result.y = e.pageY;
			}

			return result;
		}


		private onResize():void
		{
			this.stageWidth = window.innerWidth;//$(window).width();
			this.stageHeight = window.innerHeight;

			//console.log($(window).width() + " " + window.innerWidth);

			const isChange:boolean = this.checkIsSp();

			for (var i:number = 0, ln:number = this.onResizeFuncs.length; i < ln; i++)
			{
				this.onResizeFuncs[i].call(this.onResizeScopes[i], isChange);
			}

			//Debugger.text(0, "isChange " + isChange);
			//Debugger.text(1, "isSp " + AppState.isSp);
		}


		/*
		 * スマホ・PCの切替チェック
		 */
		private checkIsSp():boolean
		{
			const flag:boolean = this.stageWidth <= 768;
			const isChange:boolean = this.isSp != flag;

			this.isSp = flag;

			return isChange;
		}
	}

	export const AppState = new _AppState();
}

